// @ts-nocheck
document.addEventListener("DOMContentLoaded", function () {
  const scrollingPromotions = document.querySelectorAll(".scrolling-promotion");

  scrollingPromotions.forEach((promo) => {
    const speed = parseFloat(promo.dataset.speed) || 1.6;
    const direction = promo.classList.contains("scrolling-promotion--right")
      ? "right"
      : "left";
    const moveSpace = 100;
    const promotion = promo.querySelector(".promotion");

    if (!promotion) return;

    // Prevent re-init
    if (promo.dataset.initialized) return;
    promo.dataset.initialized = "true";

    // Add class for animation
    promotion.classList.add("promotion--animated");

    // Clone elements to make seamless scroll
    for (let i = 0; i < 10; i++) {
      const clone = promotion.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      promo.appendChild(clone);

      const imageWrapper = clone.querySelector(".media-wrapper");
      if (imageWrapper) imageWrapper.classList.remove("loading");
    }

    // Calculate duration
    const animationDuration = (promotion.clientWidth / moveSpace) * speed;
    promo.style.setProperty("--duration", `${animationDuration}s`);

    // Add direction-specific class
    promo.classList.add(
      direction === "right"
        ? "scrolling-promotion--right"
        : "scrolling-promotion--left"
    );

    // Pause animation when not visible
    // const observer = new IntersectionObserver(
    //   (entries) => {
    //     entries.forEach((entry) => {
    //       if (entry.isIntersecting) {
    //         promo.classList.remove("scrolling-promotion--paused");
    //       } else {
    //         promo.classList.add("scrolling-promotion--paused");
    //       }
    //     });
    //   },
    //   { rootMargin: "0px 0px 50px 0px" }
    // );

    // observer.observe(promo);
  });
});
